import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/evcs_notification_orders',
  component: Management,
  redirect: '/evcs_notification_orders/list',
  children: [
    // 列表页
    {
      path: 'list',
      redirect: 'list/all',
      component: () => import('@/views/evcs_notification_orders/List'),
      meta: {
        auth: Auth.listEvcsNotificationOrders
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/evcs_notification_orders/ListTable'),
          meta: {
            auth: Auth.listEvcsNotificationOrders,
            tabName: 'all'
          }
        }
      ]
    }
  ]
}
